export const BUBBLE_DESIGN = ["standard", "expanded"];
export const WIDGET_DESIGN = ["standard", "flat"];
export const DARK_MODE = ["auto", "light", "dark"];
